import { useState } from "react";
import { Alert } from "react-bootstrap";

const DISMISS_KEY = "soloOrganizationBanner:dismissed";

const readDismissed = () => {
    try {
        return window.localStorage.getItem(DISMISS_KEY) === "1";
    } catch {
        return false;
    }
};

const writeDismissed = () => {
    try {
        window.localStorage.setItem(DISMISS_KEY, "1");
    } catch {
        // localStorage may be blocked (private mode, storage disabled); a
        // banner that reappears is a better failure mode than a crash.
    }
};

/**
 * One-time explainer shown at the top of Partner Details for super admins
 * on a partner that holds exactly one active user. It exists so a super
 * admin returning to the page after the solo-shape work shipped sees a
 * short note about why the Teams section is no longer visible, rather
 * than assuming something is missing. Dismissal is per-device via
 * localStorage; the note is low-risk to re-show on a fresh browser.
 */
const SoloOrganizationBanner = ({ show }) => {
    const [dismissed, setDismissed] = useState(() => readDismissed());

    if (!show || dismissed) return null;

    const handleClose = () => {
        writeDismissed();
        setDismissed(true);
    };

    return (
        <Alert variant="info" className="mb-3">
            <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
                <div className="flex-grow-1">
                    <strong>We tidied up your Organization page for solo use.</strong>{" "}
                    Teams are hidden until you invite another user.
                </div>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={handleClose}
                    aria-label="Dismiss this notice"
                >
                    Dismiss
                </button>
            </div>
        </Alert>
    );
};

export default SoloOrganizationBanner;
